import { atom } from 'recoil';
import { localStorageEffect } from '../utils/localstorage';

export const userIdState = atom<number | null>({
  key: 'userIdState',
  default: null,
  effects: [localStorageEffect('userId')],
});

interface userInforRecoil {
  passid: string;
  password: string;
}

export const userInforRecoilState = atom<userInforRecoil | null>({
  key: 'userInforRecoilState',
  default: null,
  effects: [localStorageEffect('userInfor')],
});
